<script lang="ts">
import {defineComponent} from 'vue'
import SumupCheckoutWidgetModal from "@/components/Global/Payment/SumupCheckoutWidgetModal.vue";
import FormField from "@/components/Global/Form/FormField.vue";
import {methodBankTransfer, methodOptions, methodSumup, Payment} from "@/interfaces/payment";
import FileUpload, {FileUploadSelectEvent} from "primevue/fileupload";
import priceFormat from "@/helpers/priceFormat"
import {fetchWrapper} from "@/helpers/fetchWrapper"
import backendRoutes from "@/backendRoutes"
import SelectButton from "primevue/selectbutton"
import isNull from "@/helpers/isNull";

export default defineComponent({
  name: "PaymentProcessor",
  props: {
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    paymentItems: {
      type: Object,
      required: true
    },
    paymentType: {
      type: String,
      required: true
    }
  },
  components: {
    FormField,
    SumupCheckoutWidgetModal,
    FileUpload,
    SelectButton
  },
  data() {
    return {
      paymentMethod: methodSumup as string,
      paymentReceipt: null as File | null,
      sumupPaymentStatus: null as string | null,
      payment: null as Payment | null,
      methodOptions: methodOptions,
      methodBankTransfer: methodBankTransfer as string,
      methodSumup: methodSumup as string,
      fileUploadError: false as boolean,
      tryToProcess: false as boolean
    }
  },
  methods:{
    priceFormat,
    isNull,
    async postPaymentCreation() {
      let errorCheck = false

      const body = {
        items:{
          ...this.paymentItems
        },
        type: this.paymentType,
        method: this.paymentMethod,
      }

      const response = await fetchWrapper.post(backendRoutes.payment_create_witch_checkout, body, undefined, {paymentReceipt: this.paymentReceipt}).catch((error) => {
        if(error === "file_error") this.$toast.add({severity:'error', summary: this.$t('global_components.payment_processor.messages.error_title'), detail: this.$t('global_components.payment_processor.messages.errors.file_error'), life: 5000})
        else if(error === "file_too_large") this.$toast.add({severity:'error', summary: this.$t('global_components.payment_processor.messages.error_title'), detail: this.$t('global_components.payment_processor.messages.errors.file_too_large'), life: 5000})
        this.$toast.add({severity:'error', summary: this.$t('global_components.payment_processor.messages.error_title'), detail: error, life: 5000});
        errorCheck = true;
      })

      if(!errorCheck){
        this.payment = response
        this.$emit('paymentCreated', this.payment)

        if(this.paymentMethod == methodSumup && this.payment && this.payment.amount && this.payment.amount > 0){
          const sumupCheckoutWidgetModal = this.$refs.sumupCheckoutWidgetModal as typeof SumupCheckoutWidgetModal
          sumupCheckoutWidgetModal.open()
        }else{
          this.$emit('paymentCompleted')
        }
      }
    },
    getRegisterPaymentMethodLabel(value: string){
      return this.$t("admin_views.student.item.messages.register_payment_method_label."+value)
    },
    paymentReceiptSelect(e: FileUploadSelectEvent){
      if(e.files.length > 1){
        return
      }
      if(e.files[0].size > 104857600){
        this.fileUploadError = true
        this.$toast.add({severity:'error', summary: this.$t('global_components.payment_processor.messages.error_title'), detail: this.$t('global_components.payment_processor.messages.errors.file_too_large'), life: 5000})
        return
      }
      this.paymentReceipt = e.files[0]
    },
    paymentReceiptRemove(){
      this.paymentReceipt = null
    },
    paymentStatusChange(status: string){
      this.sumupPaymentStatus = status;
      const sumupCheckoutWidgetModal = this.$refs.sumupCheckoutWidgetModal as typeof SumupCheckoutWidgetModal
      sumupCheckoutWidgetModal.close()
      this.$emit('paymentStatusChange', status)
      if(status == "PAID" || status == "PENDING"){
        this.$emit('paymentCompleted')
      }
    },
    processPayment(){
      let errorCheck = false
      this.tryToProcess = true
      // if(this.paymentMethod === methodBankTransfer){
      //   this.fileUploadError = this.paymentReceipt == null
      //   if(this.paymentMethod == null) errorCheck = true
      //   if(this.paymentMethod == methodBankTransfer && this.paymentReceipt == null) errorCheck = true
      //
      //   if(!errorCheck){
      //     if(this.payment != null && ((this.paymentMethod == methodSumup && this.sumupPaymentStatus == "PENDING" || this.sumupPaymentStatus == "PAID") ||
      //         this.paymentMethod == methodBankTransfer && this.payment.status == statusPaid)) this.$emit('paymentCompleted')
      //     else this.postPaymentCreation()
      //   }
      // }else
      if(this.paymentMethod === methodSumup){
        this.postPaymentCreation()
      }

      if(errorCheck){
        this.$toast.add({severity:'error', summary: this.$t('global.messages.fields_invalid.title'), detail: this.$t('global.messages.fields_invalid.content'), life: 5000})
      }
    }
  },
  emits: ['paymentStatusChange','paymentCreated','paymentCompleted'],
})
</script>

<template>
  <SelectButton v-model="paymentMethod" :options="methodOptions" :optionLabel="getRegisterPaymentMethodLabel" :invalid="(tryToProcess && paymentMethod == null)" />
  <div v-if="paymentMethod === methodBankTransfer">
    <div class="bank_transfer_text_container">
      <slot name="bankTransferText"></slot>
    </div>
    <FormField :label="$t('global_components.payment_processor.view.payment_receipt')" required>
      <FileUpload :multiple="false" :maxFileSize="104857600" :fileLimit="1" @select="paymentReceiptSelect" @remove="paymentReceiptRemove"
                  :showCancelButton="false" :showUploadButton="false" :customUpload="true" :chooseLabel="$t('global_components.payment_processor.view.choose_button')"
                  :pt="{
                              root: {
                                class: (fileUploadError || tryToProcess > 2 && isNull(paymentReceipt)) ? 'p-invalid' : ''
                              },
                               fileThumbnail: {
                                 style: 'display: none'
                              },
                              pcProgressBar: {
                               root: {
                                 style: 'display: none'
                               }
                              },
                              pcFileBadge: {
                                root: {
                                  style:'display: none'
                                }
                              }
                            }
                ">
        <template #empty>
          <span>{{ $t('global_components.payment_processor.view.upload_text') }}</span>
        </template>
      </FileUpload>
    </FormField>
  </div>
  <div v-if="paymentMethod === methodSumup">
    <p>{{ $t('global_components.payment_processor.view.payment_sumup_infos') }}</p>
    <SumupCheckoutWidgetModal ref="sumupCheckoutWidgetModal" :checkoutId="payment?.sumupCheckoutId" @statusChange="paymentStatusChange" />
  </div>
</template>

<style scoped lang="scss">
.p-fileupload.p-invalid{
  border-color: var(--p-form-field-invalid-border-color);
}
.bank_transfer_text_container{
  margin: 1rem 0;
}
p{
  display: block;
  margin: 1rem 0;
}
</style>
